module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/object-status/object-status.component.scss
// module id = ./src/app/shared/object-status/object-status.component.scss
// module chunks = main